import { Component, inject, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  PreviewPlanActivationResponse,
  SubscriptionsService
} from '../../../../services/subscriptions'
import {
  PaymentsService,
  SubscriptionInitiationResponse
} from '../../../../services/payments.service'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  filter,
  map,
  Observable,
  switchMap,
  take,
  tap,
  catchError,
  timer,
  retry
} from 'rxjs'
import { eps } from '../../../../services/url.service'
import { AuthState, selectSubscription, selectUser } from '../../../../store/auth/auth.state'
import { CommonModule } from '@angular/common'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { RazorpayService } from '../../../../services/razorpay.service'
import { logout } from '../../../../store/auth/auth.actions'
import { FormsModule } from '@angular/forms'
import { UserService } from '../../../../services/user.service'

@Component({
  selector: 'app-activate-plan',
  imports: [CommonModule, CapitalizePipe, FormsModule],
  templateUrl: './activate-plan.component.html',
  styleUrl: './activate-plan.component.scss'
})
export class ActivatePlanComponent implements OnInit {
  private store = inject(Store)
  private subscriptionsService = inject(SubscriptionsService)
  private razorpayService = inject(RazorpayService)
  private paymentsService = inject(PaymentsService)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private toastr = inject(ToastrService)
  private userService = inject(UserService)

  selectedPlanId!: string
  currentSubscriptionId!: string
  businessId!: string
  isProcessingPayment = false
  wantsAutopay = false
  planActivationSummary$!: Observable<PreviewPlanActivationResponse>
  user: AuthState['user'] | null = null
  private userInputLicences$ = new BehaviorSubject<number | null>(null)
  licenceCount = 0
  couponCode = ''
  private couponCode$ = new BehaviorSubject<string>('')
  showCouponInput = false
  appliedCoupon = ''
  currentSummary!: PreviewPlanActivationResponse
  actionType = ''
  ngOnInit(): void {
    const selectedPlanId = this.route.snapshot.paramMap.get('id')
    if (!selectedPlanId) this.router.navigate([eps.hrm.upgradePlanPath])
    else this.selectedPlanId = selectedPlanId

    const queryLicenseCount = Number(this.route.snapshot.queryParamMap.get('licencesCount'))
    this.actionType = this.route.snapshot.queryParamMap.get('action') ?? 'Purchase'

    const initialData$ = combineLatest([
      this.store.select(selectSubscription),
      this.store.select(selectUser).pipe(map(user => user?.businessId))
    ]).pipe(
      filter(([sub, busId]) => !!sub && !!busId),
      take(1),
      tap(([sub, busId]) => {
        this.currentSubscriptionId = sub?.id!
        this.businessId = busId!
        // this.licenceCount = sub?.minimumLicences ?? 2

        // this.userInputLicences$.next(this.licenceCount)

        const minLicences = sub?.minimumLicences ?? 2

        this.licenceCount =
          queryLicenseCount > 0
            ? Math.max(queryLicenseCount, minLicences, sub?.licencesForNextCycle ?? 0)
            : minLicences
        // console.log('query licence', this.licenceCount)
        this.userInputLicences$.next(this.licenceCount)
      })
    )

    // The main reactive stream. It re-triggers whenever the license count changes.
    // this.planActivationSummary$ = combineLatest([
    //   initialData$,
    //   this.couponCode$,
    //   this.userInputLicences$.pipe(debounceTime(300), distinctUntilChanged())
    // ]).pipe(
    //   switchMap(([[sub, busId], couponCode, licencesCount]) => {
    //     if (!sub || !busId) {
    //       return EMPTY
    //     }

    //     const finalLicenceCount = licencesCount ?? sub?.minimumLicences ?? 2
    //     return this.subscriptionsService.previewPlanActivation(
    //       sub.id,
    //       this.selectedPlanId,
    //       busId!,
    //       Number(finalLicenceCount),
    //       couponCode
    //     )
    //   }),
    //   tap(summary => {
    //     if (this.userInputLicences$.value === null) {
    //       this.userInputLicences$.next(summary.plan.requestedLicences)
    //     }
    //   })
    // )

    this.planActivationSummary$ = combineLatest([
      initialData$,
      this.couponCode$,
      this.userInputLicences$.pipe(debounceTime(300), distinctUntilChanged())
    ]).pipe(
      switchMap(([[sub, busId], couponCode, licencesCount]) => {
        if (!sub || !busId) {
          return EMPTY
        }
        // console.log('liceneces count', licencesCount)
        const finalLicenceCount = licencesCount ?? sub?.minimumLicences ?? 2

        return this.subscriptionsService
          .previewPlanActivation(
            sub.id,
            this.selectedPlanId,
            busId,
            Number(finalLicenceCount),
            couponCode
          )
          .pipe(
            catchError((error: unknown) => {
              // console.log('error', error)
              if (couponCode) {
                this.couponCode = ''
                this.appliedCoupon = ''
                this.couponCode$.next('')
              }

              return EMPTY
            })
          )
      }),
      tap(summary => {
        // if (this.userInputLicences$.value === null) {
        //   this.userInputLicences$.next(summary.plan.requestedLicences)
        // }
        // if (this.userInputLicences$.value === null) {
        //   this.licenceCount = summary.plan.requestedLicences
        //   this.userInputLicences$.next(summary.plan.requestedLicences)
        // }
        this.currentSummary = summary
        const usedLicences = Number(summary.plan.usedLicences ?? 0)
        if (this.licenceCount < usedLicences) {
          this.licenceCount = usedLicences
        }
        // this.userInputLicences$.next(usedLicences)
        // const licencesForNextCycle = Number(summary.plan.licencesForNextCycle)
        // if (licencesForNextCycle > 0 && this.licenceCount < licencesForNextCycle) {
        //   this.licenceCount = licencesForNextCycle
        // }
        // console.log('preview response licence:', summary.plan.requestedLicences)
      })
    )

    this.store
      .select(selectUser)
      .pipe(
        take(1),
        tap(user => {
          this.user = user
        })
      )
      .subscribe()
  }

  // onLicenceChange(newCount: number, minLicences: number): void {
  //   const validatedCount = Math.max(minLicences, Number(newCount) || minLicences)
  //   this.userInputLicences$.next(validatedCount)
  // }

  //getPaymentLink() {
  //  this.planActivationSummary$.pipe(take(1)).subscribe(summary => {
  //    const finalLicencesCount = summary.plan.requestedLicences
  //    this.paymentsService
  //      .getActivationPaymentLink(
  //        this.currentSubscriptionId,
  //        this.selectedPlanId,
  //        finalLicencesCount
  //      )
  //      .pipe(take(1))
  //      .subscribe(r => {
  //        if (r.message && !r.paymentNeeded && !r.redirectUrl) {
  //          this.toastr.success(r.message)
  //          this.router.navigate([eps.planAndBilling.planPath])
  //        }
  //        if (r.paymentNeeded && r.redirectUrl) window.location.href = r.redirectUrl
  //      })
  //  })
  //}

  // before 27 july 2026
  // activateSubscription(): void {
  //   if (this.isProcessingPayment) return
  //   this.isProcessingPayment = true
  //   // console.log('licenceCount sending before:', this.licenceCount)
  //   const licence = this.licenceCount
  //   this.planActivationSummary$.pipe(take(1)).subscribe(summary => {
  //     // console.log('summary', summary)
  //     // console.log('licenceCount sending:', this.licenceCount)
  //     const finalLicencesCount = licence
  //     const isYearlyPlan = summary.plan.billingFrequency?.toLowerCase() === 'yearly'
  //     const couponToSend = isYearlyPlan ? undefined : this.couponCode.trim() || undefined
  //     this.paymentsService
  //       .initiateSubscription(
  //         this.currentSubscriptionId,
  //         this.selectedPlanId,
  //         finalLicencesCount,
  //         this.user?.businessId,
  //         couponToSend
  //       )
  //       .pipe(take(1))
  //       .subscribe({
  //         next: response => {
  //           this.showRazorpayCheckout(response, summary)
  //         },
  //         error: err => {
  //           this.isProcessingPayment = false
  //           this.toastr.error(err.error?.message || 'Failed to initiate payment. Please try again.')
  //         }
  //       })
  //   })
  // }

  //27 july 2026
  activateSubscription(): void {
    if (this.isProcessingPayment) return

    this.isProcessingPayment = true

    const summary = this.currentSummary

    const isYearlyPlan = summary.plan.billingFrequency?.toLowerCase() === 'yearly'

    const couponToSend = isYearlyPlan ? undefined : this.couponCode.trim() || undefined

    this.paymentsService
      .initiateSubscription(
        this.currentSubscriptionId,
        this.selectedPlanId,
        this.licenceCount,
        this.user?.businessId,
        couponToSend,
        this.wantsAutopay
      )
      .pipe(take(1))
      .subscribe({
        next: response => {
          this.showRazorpayCheckout(response, summary)
        },
        error: err => {
          this.isProcessingPayment = false
          this.toastr.error(err.error?.message || 'Failed to initiate payment.')
        }
      })
  }

  //kripesh
  // private showRazorpayCheckout(
  //   initiationResponse: SubscriptionInitiationResponse,
  //   summary: PreviewPlanActivationResponse
  // ): void {
  //   this.razorpayService
  //     .load()
  //     .then(() => {
  //       const options = {
  //         key: initiationResponse.key,
  //         // Use order_id for monthly (prorated) or subscription_id for yearly
  //         ...(initiationResponse.type === 'order' && {
  //           order_id: initiationResponse.orderId,
  //           amount: initiationResponse.amount,
  //           currency: initiationResponse.currency
  //         }),
  //         ...(initiationResponse.type === 'subscription' && {
  //           subscription_id: initiationResponse.subscriptionId
  //         }),

  //         name: 'AVR HRMS',
  //         description: `Activating ${summary.plan.name}`,

  //         handler: (response: any) => {
  //           // This function is called on successful payment
  //           console.log('Razorpay success response', response)
  //           this.toastr.success('Payment successful! Your plan is being activated.')
  //           // Navigate the user to a success page.
  //           this.router.navigate([eps.planAndBilling.planPath])
  //         },

  //         prefill: {
  //           // You can prefill user details from your store if available
  //           name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
  //           email: this.user?.email ?? '',
  //           contact: this.user?.mobile ?? ''
  //         },

  //         notes: {
  //           plan: summary.plan.name,
  //           licences: summary.plan.requestedLicences
  //         },

  //         modal: {
  //           ondismiss: () => {
  //             this.isProcessingPayment = false
  //             this.toastr.info('Payment was not completed.')
  //           }
  //         },

  //         theme: {
  //           color: '#3399cc' // Your brand color
  //         }
  //       }

  //       // Create and open the Razorpay Checkout
  //       const rzp = new window.Razorpay(options)
  //       rzp.open()
  //     })
  //     .catch(error => {
  //       console.error('Failed to load Razorpay script', error)
  //       this.toastr.error(
  //         'Could not connect to the payment gateway. Please check your connection and try again.'
  //       )
  //       this.isProcessingPayment = false
  //     })
  // }

  //gps 25 feb 2026 for monthly subscription active
  // private showRazorpayCheckout(
  //   initiationResponse: SubscriptionInitiationResponse,
  //   summary: PreviewPlanActivationResponse
  // ): void {
  //   this.razorpayService
  //     .load()
  //     .then(() => {
  //       const options = {
  //         key: initiationResponse.key,
  //         // Use order_id for monthly (prorated) or subscription_id for yearly
  //         ...(initiationResponse.type === 'order' && {
  //           order_id: initiationResponse.orderId,
  //           amount: initiationResponse.amount,
  //           currency: initiationResponse.currency
  //         }),
  //         ...(initiationResponse.type === 'subscription' && {
  //           subscription_id: initiationResponse.subscriptionId
  //         }),

  //         name: 'AVR HRMS',
  //         description: `Activating ${summary.plan.name}`,

  //         handler: (response: any) => {
  //           // This function is called on successful payment
  //           console.log('Razorpay success response', response)
  //           console.log('initiationResponse', initiationResponse)
  //           console.log('initiationResponse subscriptionId', response.razorpay_payment_id)
  //           if (initiationResponse.type === 'order' && response.razorpay_payment_id) {
  //             // STEP 1 COMPLETE → NOW AUTHENTICATE MANDATE

  //             this.paymentsService
  //               .authenticateMandate(response.razorpay_payment_id)
  //               .subscribe(res => {
  //                 const mandateOptions = {
  //                   key: res.key,
  //                   subscription_id: res.subscriptionId,
  //                   name: 'AVR HRMS',
  //                   description: 'Enable Auto Debit'
  //                 }

  //                 const mandateRzp = new window.Razorpay(mandateOptions)
  //                 mandateRzp.open()
  //               })
  //           } else {
  //             // Yearly flow
  //             this.router.navigate([eps.planAndBilling.planPath])
  //           }
  //           this.toastr.success('Payment successful! Your plan is being activated.')
  //           // const subscription = JSON.parse(localStorage.getItem('subscription') || '{}')

  //           // if (subscription?.subscriptionStatus?.toLowerCase() === 'expired') {
  //           //   // localStorage.clear();
  //           //   this.store.dispatch(logout())
  //           //   // optional: redirect to login page
  //           //   this.router.navigate(['/login'])
  //           // }
  //           // Navigate the user to a success page.
  //           this.router.navigate([eps.planAndBilling.planPath])
  //         },

  //         prefill: {
  //           // You can prefill user details from your store if available
  //           name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
  //           email: this.user?.email ?? '',
  //           contact: this.user?.mobile ?? ''
  //         },

  //         notes: {
  //           plan: summary.plan.name,
  //           licences: summary.plan.requestedLicences
  //         },

  //         modal: {
  //           ondismiss: () => {
  //             this.isProcessingPayment = false
  //             this.toastr.info('Payment was not completed.')
  //           }
  //         },

  //         theme: {
  //           color: '#3399cc' // Your brand color
  //         }
  //       }

  //       // Create and open the Razorpay Checkout
  //       const rzp = new window.Razorpay(options)
  //       rzp.open()
  //     })
  //     .catch(error => {
  //       console.error('Failed to load Razorpay script', error)
  //       this.toastr.error(
  //         'Could not connect to the payment gateway. Please check your connection and try again.'
  //       )
  //       this.isProcessingPayment = false
  //     })
  // }

  //gps 15 may 2026 plan renew too, monthly subscription active
  private showRazorpayCheckout(
    initiationResponse: SubscriptionInitiationResponse,
    summary: PreviewPlanActivationResponse
  ): void {
    this.razorpayService
      .load()
      .then(() => {
        const options = {
          key: initiationResponse.key,

          // Monthly / prorated flow
          ...(initiationResponse.type === 'order' && {
            order_id: initiationResponse.orderId,
            amount: initiationResponse.amount,
            currency: initiationResponse.currency
          }),

          // Yearly subscription flow
          ...(initiationResponse.type === 'subscription' && {
            subscription_id: initiationResponse.subscriptionId
          }),

          name: 'AVR HRMS',
          description: `Activating ${summary.plan.name}`,

          handler: (response: any) => {
            console.log('Razorpay success response', response)

            // =========================
            // MONTHLY FLOW
            // =========================
            if (initiationResponse.type === 'order' && response.razorpay_payment_id) {
              if (!this.wantsAutopay) {
                this.toastr.success('Payment successful! Subscription activated.')
                this.isProcessingPayment = false
                // this.checkSubscriptionAndLogout()
                // Fetch subscription -> localStorage -> refresh
                this.fetchAndSaveCurrentSubscription(this.businessId)

                setTimeout(() => {
                  window.location.reload()
                }, 500)
                this.router.navigate([eps.planAndBilling.billingPath])
                return
              }
              this.paymentsService.authenticateMandate(response.razorpay_payment_id).subscribe({
                next: res => {
                  const mandateOptions = {
                    key: res.key,
                    subscription_id: res.subscriptionId,
                    name: 'AVR HRMS',
                    description: 'Enable Auto Debit',

                    handler: () => {
                      this.toastr.success('Subscription activated successfully!')

                      // CHECK UPDATED SUBSCRIPTION STATUS
                      // this.checkSubscriptionAndLogout()

                      // Fetch UPDATED subscription only after mandate
                      this.fetchAndSaveCurrentSubscription(this.businessId)

                      // Refresh after subscription has been fetched
                      setTimeout(() => {
                        window.location.reload()
                      }, 500)
                    },

                    modal: {
                      ondismiss: () => {
                        this.isProcessingPayment = false

                        this.toastr.warning('Mandate authentication was cancelled.')
                      }
                    },

                    theme: {
                      color: '#3399cc'
                    }
                  }

                  const mandateRzp = new window.Razorpay(mandateOptions)

                  mandateRzp.open()
                },

                error: err => {
                  console.error('Mandate authentication failed', err)

                  this.toastr.error('Failed to authenticate mandate.')

                  this.isProcessingPayment = false
                }
              })
              // this.checkSubscriptionAndLogout()
              return
            }

            // =========================
            // YEARLY FLOW
            // =========================

            this.toastr.success('Payment successful! Subscription activated.')

            // CHECK UPDATED SUBSCRIPTION STATUS
            // this.checkSubscriptionAndLogout()
            // Fetch subscription -> localStorage -> refresh
            this.fetchAndSaveCurrentSubscription(this.businessId)

            setTimeout(() => {
              window.location.reload()
            }, 500)
            this.router.navigate([eps.planAndBilling.billingPath])
          },

          prefill: {
            name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
            email: this.user?.email ?? '',
            contact: this.user?.mobile ?? ''
          },

          notes: {
            plan: summary.plan.name,
            licences: summary.plan.requestedLicences
          },

          modal: {
            ondismiss: () => {
              this.isProcessingPayment = false

              this.toastr.info('Payment was not completed.')
            }
          },

          theme: {
            color: '#3399cc'
          }
        }

        const rzp = new window.Razorpay(options)

        rzp.open()
      })
      .catch(error => {
        console.error('Failed to load Razorpay script', error)

        this.toastr.error(
          'Could not connect to the payment gateway. Please check your connection and try again.'
        )

        this.isProcessingPayment = false
      })
  }

  // =====================================
  // CHECK SUBSCRIPTION STATUS + LOGOUT
  // =====================================

  private checkSubscriptionAndLogout(): void {
    // wait for backend/localStorage update
    setTimeout(() => {
      const subscription = JSON.parse(localStorage.getItem('subscription') || '{}')

      console.log('Updated subscription status:', subscription?.subscriptionStatus)

      if (subscription?.subscriptionStatus?.toLowerCase() === 'expired') {
        // Show success toast first
        this.toastr.success('Plan activated successfully. Redirecting to login...')

        // Delay logout so toast can be visible
        setTimeout(() => {
          this.store.dispatch(logout())

          localStorage.clear()

          this.router.navigate(['/login'])
        }, 2500) // 2.5 seconds delay

        return
      }

      this.toastr.warning('Subscription status not updated yet.')

      this.router.navigate([eps.planAndBilling.billingPath])
    }, 3000)
  }

  onLicenceInput(value: number, minLicences: number) {
    const validatedCount = Math.max(minLicences, Number(value) || minLicences)

    this.licenceCount = validatedCount
    this.userInputLicences$.next(this.licenceCount)
  }

  // onLicenceChange(delta: number, minLicences: number) {
  //   const current = Number(this.licenceCount) || minLicences

  //   this.licenceCount = Math.max(minLicences, current + delta)

  //   this.userInputLicences$.next(this.licenceCount)
  // }

  onLicenceChange(delta: number, minLicences: number) {
    const current = Number(this.licenceCount) || minLicences

    this.licenceCount = Math.max(minLicences, current + delta)

    console.log('changed licence:', this.licenceCount)

    this.userInputLicences$.next(this.licenceCount)
  }

  // applyCoupon() {
  //   this.couponCode$.next(this.couponCode.trim())
  // }

  applyCoupon() {
    const code = this.couponCode.trim()

    if (!code) return
    this.appliedCoupon = code
    this.couponCode$.next(code)

    // Hide input after apply
    this.showCouponInput = false
  }

  toggleCouponInput() {
    if (!this.showCouponInput) {
      this.couponCode = ''
      this.appliedCoupon = ''
    }
    this.showCouponInput = !this.showCouponInput

    // Cancel hone par input clear ho jaye
    if (!this.showCouponInput) {
      this.couponCode = ''
      this.appliedCoupon = ''
    }

    this.couponCode$.next(this.couponCode)
  }

  // private fetchAndSaveCurrentSubscription(): void {
  //   this.userService.getCurrentSubscription().subscribe({
  //     next: subscription => {
  //       console.log('Current subscription:', subscription)

  //       localStorage.setItem('currentSubscription', JSON.stringify(subscription))
  //     },
  //     error: err => {
  //       console.error('Failed to fetch current subscription', err)
  //     }
  //   })
  // }

  // private fetchAndSaveCurrentSubscription(businessId: string): void {
  //   this.userService.getCurrentSubscription(businessId).subscribe({
  //     next: subscription => {
  //       console.log('Current subscription:', subscription)

  //       localStorage.setItem('subscription', JSON.stringify(subscription))
  //     },
  //     error: err => {
  //       console.error('Failed to fetch current subscription', err)
  //     }
  //   })
  // }

  private fetchAndSaveCurrentSubscription(businessId: string): void {
    let attempt = 0
    const maxAttempts = 5

    this.userService
      .getCurrentSubscription(businessId)
      .pipe(
        retry({
          count: maxAttempts - 1,
          delay: (error, retryCount) => {
            attempt = retryCount

            console.warn(
              `Failed to fetch current subscription. Retry ${retryCount}/${maxAttempts - 1} after 1 minute.`,
              error
            )

            return timer(60000)
          }
        })
      )
      .subscribe({
        next: subscription => {
          console.log('Current subscription fetched successfully:', subscription)

          localStorage.setItem('subscription', JSON.stringify(subscription))

          this.toastr.success('Subscription updated successfully.')

          // Reload only after successful API response
          setTimeout(() => {
            window.location.reload()
          }, 500)
          this.router.navigate([eps.planAndBilling.billingPath])
        },

        error: err => {
          console.error(`Failed to fetch current subscription after ${maxAttempts} attempts.`, err)

          this.isProcessingPayment = false

          this.toastr.error(
            'Subscription payment was successful, but we could not update your subscription details. Please try again later.'
          )
        }
      })
  }
}
